import { createContext } from "react";

const BrandingColorContext = createContext<boolean>(false);

export default BrandingColorContext;
